import { render, staticRenderFns } from "./RemoveAccountPage.vue?vue&type=template&id=4e44646e&scoped=true&"
import script from "./RemoveAccountPage.vue?vue&type=script&lang=js&"
export * from "./RemoveAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./RemoveAccountPage.vue?vue&type=style&index=0&id=4e44646e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e44646e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e44646e')) {
      api.createRecord('4e44646e', component.options)
    } else {
      api.reload('4e44646e', component.options)
    }
    module.hot.accept("./RemoveAccountPage.vue?vue&type=template&id=4e44646e&scoped=true&", function () {
      api.rerender('4e44646e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RemoveAccountPage.vue"
export default component.exports